/** @format */

import React, { memo } from 'react';

import moment from 'moment';
import styled from 'styled-components';

import CalendarIcon from '../../../../assets/icons/dovevivo_icon_calendar_squared.svg';
import { utilityIsRoomAvailableFrom } from '../../../../utils/helpers/isRoomAvailableFrom';
import { UIText } from '../../../ui/Text';
import { TReducerBooking } from '../../../../@ducks/booking/selectors';

// #region ::: COMPONENTS
const Date = styled.h5`
  color: rgba(40, 40, 40, 0.9);
  font-family: ${({ theme }) => theme.font.body};
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 0 8px;
  text-align: left;
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 2px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

// #endregion

interface Props {
  date?: string;
  availability: TReducerBooking['availability'];
}

export const AvailableFrom = memo(({ date, availability }: Props) => {
  const availableDate = moment(date).format('DD/MM/YYYY');
  const isRoomAvailableFrom = utilityIsRoomAvailableFrom(availability);

  return (
    <Container>
      {!availability?.availableFrom || date === ('notAvailable' || undefined) || availability?.negotiating === true ? (
        <Date>
          <UIText text="general_unavailable" intlFormatter />
        </Date>
      ) : (
        <>
          <img src={CalendarIcon} alt="calendar-icon" />
          <Date>
            {isRoomAvailableFrom ? (
              <>
                <UIText text="card_availability_available_from" intlFormatter /> {availableDate}
              </>
            ) : (
              <UIText text="general_available" intlFormatter />
            )}
          </Date>
        </>
      )}
    </Container>
  );
});
